import React from 'react';

import { IParsedMyAccountSidebarMenuItem } from '@core/js/components/main/MyAccountSidebar/types';

import { CUSTOM_CSS_CLASSES } from '@interlayer/js/custom/constants';
import { useCheckIsActiveLink, useCurrentItemMenu } from '@interlayer/js/custom/hooks/useMenu';
import { clsx } from '@interlayer/js/utils/classNames.util';

import style from '../../Menu.scss';

type TSidebarMenuItemProps = {
    item: IParsedMyAccountSidebarMenuItem;
    isSubMenuShown: boolean;
    isMainMenuHasIcons: unknown;
    handleMenuItemClick: (event: React.MouseEvent<HTMLAnchorElement>, item: IParsedMyAccountSidebarMenuItem) => void;
}

export const SidebarMenuItem: React.FC<TSidebarMenuItemProps> = ({
    item,
    handleMenuItemClick,
    isSubMenuShown,
    isMainMenuHasIcons
}) => {
    const checkIsActiveLink = useCheckIsActiveLink();
    const currentItemMenu = useCurrentItemMenu(item.url);
    const isMenuItemHighlight = currentItemMenu?.cssClasses
        ? currentItemMenu.cssClasses.includes(CUSTOM_CSS_CLASSES.SIDE_MENU_MY_ACCOUNT_HIGHLIGHT)
        : false;

    return (
        <a
            href="#"
            role="menuitem"
            key={item.id}
            className={
                clsx(
                    style.menuListItem,
                    { [style.isMenuItemHighlight]: isMenuItemHighlight },
                    { [style.isActiveLink]: checkIsActiveLink(item.url) }
                )
            }
            tabIndex={isSubMenuShown ? -1 : undefined}
            onClick={(event) => handleMenuItemClick(event, item)}
        >
            {Boolean(isMainMenuHasIcons) && <span className={style.icon} style={{ backgroundImage: item.iconUrl && `url("${item.iconUrl}")` }} />}

            <span className={style.name}>{item.name}</span>
        </a>
    );
};
